import { api } from "../axios";
import { SwitchTransactionOrderPayload } from "../../types";

export const createSwitchTransaction = (
  payload: SwitchTransactionOrderPayload
) => {
  return api.post("mf-switches/", payload);
};

export const deleteSwitchTransactionApi = ({
  id,
  investment_account_guid,
}: {
  investment_account_guid: string;
  id: number;
}) => {
  return api.delete(`mf-switches/${id}/`, {
    data: {
      investment_account_guid,
    },
  });
};

export const updateSwitchTransactionApi = ({
  id,
  ...payload
}: SwitchTransactionOrderPayload & { id: number }) => {
  return api.put(`mf-switches/${id}/`, payload);
};
